import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'row nowrap',
    },
    expanded: {},

    expandContainer: {
      marginRight: theme.spacing(1.5),
    },
    buttonExpand: {
      border: theme.shape.borderPrimaryLight,
      padding: theme.spacing(1 / 8),
    },
    iconExpand: {
      color: COLORS.primary.light,
      fontSize: theme.typography.pxToRem(20),

      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.short,
      }),

      '$expanded &': {
        transform: 'rotate(-180deg)',
      },
    },

    content: {
      flex: 1,
      display: 'flex',
      flexFlow: 'column nowrap',
    },
    topRow: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    bottomRow: {
      marginTop: theme.spacing(1.5),
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
    },
    iconArrow: {
      margin: theme.spacing(0, 1),
      fontSize: theme.typography.pxToRem(20),
      color: COLORS.primary.default,
    },
    termText: {
      width: 'calc((100% - 36px) / 2)',
    },
    shrunk: {
      width: 97,
    },
  }),
  { name: 'RuleHeader' }
);
